import React, { useState } from 'react'
import { StyledModal, ModalHeading, ModalBody, CloseButton } from '../index.styled';
import ToyotaButton from '../../ToyotaButton';
import Typography from '../../Typography';
import { useTranslation } from 'react-i18next';
import CloseModalIcon from '../../../icons/close_modal.svg'

export const ConfirmationModal = ({ success, hasError }) => {
  const [isOpen, setIsOpen] = useState(success)
  const { t } = useTranslation();

  function toggleModal(e) {
    setIsOpen(!isOpen)
  }
  const successfullySubmitted = hasError ? 'onError' : 'onSuccess'

  return (
    <div>
      <StyledModal
        hasError={hasError}
        isOpen={isOpen}
        onBackgroundClick={toggleModal}
        onEscapeKeydown={toggleModal}>
        <ModalHeading onClick={toggleModal}>
          <CloseButton src={CloseModalIcon} alt='Close' width='30px' height='30px' />
        </ModalHeading>
        <ModalBody>
          <Typography.Heading3>{t(`FormData.Confirmation.${successfullySubmitted}.heading`)}</Typography.Heading3>
          <Typography.Body>{t(`FormData.Confirmation.${successfullySubmitted}.body`)}</Typography.Body>
          <ToyotaButton>
            <Typography.BodyBold onClick={toggleModal}>{t('FormData.Confirmation.CTAButton')}</Typography.BodyBold>
          </ToyotaButton>
        </ModalBody>
      </StyledModal>
    </div>
  )
}